// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"styles_buttonsContainer__10vXs","buttonCancel":"styles_buttonCancel__JuFcF"};